import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useRestoreFile } from '../../hooks/useRecycleBin';

interface RestoreCollisionDialogProps {
  open: boolean;
  onClose: () => void;
  conflictInfo: {
    conflictingFileId: string;
    conflictingFileName: string;
    targetFolderId: string | null;
  };
  fileId: string;
  fileName: string;
  siteId?: number;
}

export function RestoreCollisionDialog({
  open,
  onClose,
  conflictInfo,
  fileId,
  fileName,
  siteId,
}: RestoreCollisionDialogProps) {
  const restoreFile = useRestoreFile(siteId);

  const handleRename = () => {
    const ext = fileName.lastIndexOf('.');
    const baseName = ext > 0 ? fileName.substring(0, ext) : fileName;
    const extension = ext > 0 ? fileName.substring(ext) : '';
    const newName = `${baseName} (1)${extension}`;

    restoreFile.mutate({ fileId, body: { newName } }, { onSuccess: onClose });
  };

  const handleReplace = () => {
    restoreFile.mutate(
      {
        fileId,
        body: { replaceFileId: conflictInfo.conflictingFileId },
      },
      { onSuccess: onClose }
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      data-testid="restore-collision-dialog"
    >
      <DialogTitle>File already exists</DialogTitle>
      <DialogContent>
        <DialogContentText>
          A file named &quot;{conflictInfo.conflictingFileName}&quot; already
          exists in the target folder.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleRename}
          disabled={restoreFile.isPending}
          data-testid="rename-button"
        >
          Rename
        </Button>
        <Button
          onClick={handleReplace}
          variant="contained"
          disabled={restoreFile.isPending}
          data-testid="replace-button"
        >
          Replace
        </Button>
      </DialogActions>
    </Dialog>
  );
}
